import { OrderListView, PriceListView, DeviceListView, SalesReportView } from '@/views/authenticated/admin';
import eventRoutes from './events';

export default [
  {
    path: '/admin/devices',
    name: 'app_admin_device_list',
    component: DeviceListView,
    meta: { title: 'Devices', requiresAdmin: true },
  },
  {
    path: '/admin/prices',
    name: 'app_admin_price_list',
    component: PriceListView,
    meta: { title: 'Prices', requiresAdmin: true },
  },
  {
    path: '/admin/orders',
    name: 'app_admin_order_list',
    component: OrderListView,
    meta: { title: 'Orders', requiresAdmin: true },
  },
  {
    path: '/admin/reports/sales',
    name: 'app_admin_sales_report',
    component: SalesReportView,
    meta: { title: 'Sales Report', requiresAdmin: true },
  },
  ...eventRoutes,
];
